/* istanbul ignore file */
import React from 'react';
import { PrepopulationProvider } from 'domain/people/employee/prepopulation/PrepopulationContext';
import usePrepopulation from 'domain/people/employee/prepopulation/prepopulationHelper';

const Prepopulation = ({ children, mapResponse }: { children?: React.ReactNode; mapResponse?: any }) => {
  const contextValue: any = usePrepopulation({ mapResponse });

  return <PrepopulationProvider value={contextValue}>{children}</PrepopulationProvider>;
};

export default Prepopulation;
